var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',[_vm._v("Загрузка...")]):_vm._e(),(_vm.isError)?_c('div',[_vm._v("Ошибка...")]):_vm._e(),_c('user-amount',{attrs:{"bot-name":_vm.botName}}),(!_vm.isLoading && !_vm.isError)?_c('content-table',{staticClass:"mt-30",attrs:{"column-headers":_vm.columnHeaders,"table-data":_vm.tableData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }